var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowtriangledown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.5371,
    height: 15.9473,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 15.9473,
    opacity: 0,
    width: 15.5371,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5371 1.19141C15.5371 0.46875 14.9805 0.0195312 14.1309 0.0195312L1.39648 0.00976562C0.546875 0.00976562 0 0.458984 0 1.18164C0 1.57227 0.175781 1.89453 0.371094 2.30469L6.46484 14.8535C6.875 15.6836 7.24609 15.9473 7.76367 15.9473C8.28125 15.9473 8.66211 15.6836 9.07227 14.8535L15.1562 2.30469C15.3613 1.9043 15.5371 1.58203 15.5371 1.19141Z",
    fill: "#292346",
    fillOpacity: 0.85
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowtriangledown);
export default __webpack_public_path__ + "static/media/arrowtriangle.down.f9f051b0595d76bb06bb4972254bdd73.svg";
export { ForwardRef as ReactComponent };